"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = require('../local.settings.json');
exports.default = exports.config;
